import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import React from "react";
/**
 * For the company https://bolt.eu/
 */

var BoltEuIcon = function BoltEuIcon(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    version: "1.1",
    viewBox: "0 0 693.7 407",
    style: {
      enableBackground: "new 0 0 693.7 407"
    }
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    points: "557.6,0 557.6,306 485.6,306 485.6,15.3 \t"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M352.6,86.9c-61.3,0-111.1,49.7-111.1,111.1s49.7,111.1,111.1,111.1c61.3,0,111.1-49.7,111.1-111.1 S413.9,86.9,352.6,86.9z M352.6,234c-19.9,0-36-16.1-36-36s16.1-36,36-36s36,16.1,36,36S372.5,234,352.6,234z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "352.6",
    cy: "371",
    r: "36"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.4,144.2c9-14.4,14.1-31.5,14.1-49.7C206.5,42.3,164.2,0,112,0H72H0v306h72h54c52.2,0,94.5-42.3,94.5-94.5 C220.6,185.2,209.8,161.4,192.4,144.2z M72.1,72h40c12.4,0,22.5,10.1,22.5,22.5S124.5,117,112.1,117h-40V72z M126.1,234h-54v-45h54 c12.4,0,22.5,10.1,22.5,22.5S138.5,234,126.1,234z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M693.6,163V91h-36V36l-72,15.3V163l0,0v74.1c0,0.1,0,0.2,0,0.3c0,0.1,0,0.2,0,0.2c0,43.9,27.3,69.2,67.5,71.3 c0.4,0,0.9,0.1,1.3,0.1c0.2,0,0.4,0,0.7,0c0.9,0,1.7,0.1,2.6,0.1l0,0c0.3,0,0.6,0,0.9,0c20.2,0,35.1-9,35.1-9v-53 c0,0-6.8,2.1-16.1,2.1c-14.4,0-19.9-12.6-19.9-29.7V163H693.6z"
  })));
};

export default BoltEuIcon;
//# sourceMappingURL=bolt-eu-icon.js.map